<template>
    <div class="m_nav">
        <div
            v-for="(item,index) in list"
            :key="index"
            class="item"
            :class="{'actived': currentTab === item.path.split('/')[1]}"
            @click="toPage(item.path)"
        >
            <i :class="item.icon" />
            <p>{{ language === 'en' ? item.nameEn: item.name }}</p>
        </div>
    </div>
</template>

<script>
import { getToken, getTid, setTid, getSid, setSid } from '@/utils/cookies'
export default {
    name: 'TabBar',
    props: {
        currentTab: {
            type: String,
            default: 'tougao'
        }
    },
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
            root: '',
            list: [],
            tougaoTab: [
                { name: '投稿', nameEn: 'Contribute', path: '/tougao', icon: 'iconfont icon-bianji2' },
                { name: '首页', nameEn: 'Home', path: '/homeTougao', icon: 'iconfont icon-xiazai45' },
                { name: '消息', nameEn: 'Message', path: '/message', icon: 'iconfont icon-xiaoxi' },
                { name: '我的', nameEn: 'My', path: '/my', icon: 'iconfont icon-wode' }
            ],
            examTab: [
                { name: '报名', nameEn: 'Sign', path: '/signUp', icon: 'iconfont icon-bianji2' },
                { name: '准考证', nameEn: 'Ticket', path: '/admissionTicket', icon: 'iconfont icon-credentials_icon' },
                { name: '首页', nameEn: 'Home', path: '/homeExam', icon: 'iconfont icon-xiazai45' },
                { name: '我的', nameEn: 'My', path: '/myExam', icon: 'iconfont icon-wode' },
                { name: '查分', nameEn: 'CheckScore', path: '/searchScore', icon: 'iconfont icon-chaxun1' }
            ],
            language: this.$store.getters.language
        }
    },
    mounted() {
        if (this.tid) {
            setTid(this.tid)
            this.list = this.tougaoTab
        } else if (this.sid) {
            setSid(this.sid)
            this.list = this.examTab
        }
    },

    methods: {
        toPage(url) {
            const _query = {}
            this.tid ? this.$set(_query, 'tid', this.tid) : ''
            this.sid ? this.$set(_query, 'sid', this.sid) : ''

            if (url !== '/homeTougao' && url !== 'homeExam' && !getToken()) {
                console.log(url)
                this.$router.push({ path: '/login', query: _query })
                return
            }

            this.$route.path !== url ? this.$router.push({ path: url, query: _query }) : ''
        }
    }
}
</script>

<style lang="less" scoped>
.m_nav{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background: #fff;
  border-top: 1Px solid #f5f5f5;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.05);
  font-size: 12px;
  color: #666;
  z-index: 99;

  .item{
    flex: 1;

    .iconfont{
      font-size: 20px;
      display: inline-block;
      transform: translateY(4px);
    }

    .icon-shouye,.icon-weibiaoti2fuzhi12{
      font-size: 20px;
      font-weight: bold;
    }

    p{
      font-size: 12px;
      margin-top: 10px;
    }
  }

  .actived{
    color: var(--bck);
  }
}
</style>
